<template>
  <v-app id="products-page">
    <Menu />
    <v-container grid-list-xl id="products">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <h1 class="page-title">Kies een product:</h1>
        </v-flex>
        <v-flex xs6 sm4 md4>
          <router-link :to="{name: 'Gordijnen'}">
            <v-card class="elevation-0 product-tile">
              <!-- Gordijnen -->
              <v-img class="product-image mt-3 mb-3" :src="require('../assets/producten/Gordijn.png')"></v-img>
            </v-card>
            <p class="text-xs-center mt-2">Gordijnen</p>
          </router-link>
        </v-flex>
        <v-flex xs6 sm4 md4>
          <!-- Rolgordijnen -->
          <router-link :to="{name: 'Rolgordijnen'}">
            <v-card class="elevation-0 product-tile">
              <v-img class="product-image mt-3 mb-3" :src="require('../assets/producten/Rolgordijn.png')"></v-img>
            </v-card>
            <p class="text-xs-center mt-2">Rolgordijnen</p>
          </router-link>
        </v-flex>
        <v-flex xs6 sm4 md4>
          <!-- Duettes -->
          <router-link to="/duette">
            <v-card class="elevation-0 product-tile">
              <v-img class="product-image mt-3 mb-3" :src="require('../assets/producten/Duettes.png')"></v-img>
            </v-card>
            <p class="text-xs-center mt-2">Duette / plissé</p>
          </router-link>
        </v-flex>
        <v-flex xs6 sm4 md4>
          <!-- Jalouzien -->
          <router-link to="/jaloezien">
            <v-card class="elevation-0 product-tile">
              <v-img class="product-image mt-3 mb-3" :src="require('../assets/producten/Jalouzien.png')"></v-img>
            </v-card>
            <p class="text-xs-center mt-2">Horizontale jaloeziën</p>
          </router-link>
        </v-flex>
        <v-flex xs6 sm4 md4>
          <!-- Duorol -->
          <router-link to='/duorol'>
            <v-card class="elevation-0 product-tile">
              <v-img class="product-image mt-3 mb-3" :src="require('../assets/producten/Duorol.png')"></v-img>
            </v-card>
            <p class="text-xs-center mt-2">Duorol</p>
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>


<script>
import Menu from '@/components/Menu'; // Menu
export default {
  components: {
    Menu
  }
}
</script>


<style scoped>
#products-page {
  background-color: #fff;
}

.page-title {
  color: #707070;
  font-weight: 400;
  font-size: 19px;
}

.product-title {
  font-size: 12px;
  font-weight: 500;
  color: #000;
}

.product-tile {
  border: 1px solid #d0d0d0;
}

a,
p {
  text-decoration: none;
  color: #000;
  font-weight: 500;
  font-size: 12px;
}

.product-image {
  width: 25%;
  height: 25%;
  margin: 0 auto;
}

@media screen and (max-width: 1024px) {
  .product-image {
    width: 50%;
    height: 50%;
  }
}

@media screen and (max-width: 768px) {
  .product-image {
    width: 50%;
  }
}

@media screen and (max-width: 425px) {
  #products {
    padding: 1.5em;
    padding-top: 1em;
  }
}
</style>
